module.exports = __webpack_public_path__ + "img/GAME_BUNGEOPPANG1.81ef4e04.jpg";